import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;
export const SkeletonBase = styled.div`
  background-color: ${({
  theme
}) => theme.color.surface3};
  animation: ${pulse} 1200ms cubic-bezier(0.42, 0, 0.58, 1) infinite;

  ${({
  theme
}) => theme.screenSize.mobile} {
    background-color: ${({
  theme
}) => theme.color.surface2};
  }
`;
export const SkeletonBar = styled(SkeletonBase)<{
  width?: string;
  height?: number;
  radius?: number;
}>`
  height: ${({
  height
}) => height ?? 16}px;
  border-radius: ${({
  radius
}) => radius ?? 100}px;
  width: ${({
  width
}) => width ?? '100%'};
`;
export const SkeletonCircle = styled(SkeletonBase)<{
  size?: number;
}>`
  width: ${({
  size
}) => size ?? 24}px;
  height: ${({
  size
}) => size ?? 24}px;
  border-radius: 50%;
  flex-shrink: 0;
`;
export const SkeletonRect = styled(SkeletonBase)<{
  width?: string;
  height?: string;
  radius?: number;
}>`
  width: ${({
  width
}) => width ?? '100%'};
  height: ${({
  height
}) => height ?? '100%'};
  border-radius: ${({
  radius
}) => radius ?? 12}px;
`;